import { render, staticRenderFns } from "./ClubReorder.vue?vue&type=template&id=93abb504&scoped=true&"
import script from "./ClubReorder.vue?vue&type=script&lang=js&"
export * from "./ClubReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93abb504",
  null
  
)

export default component.exports